// src/components/rules/RuleCard.js
import React from 'react';

function RuleCard({ rule }) {
  const getSeverityColor = (severity) => {
    switch(severity) {
      case 'critical': return '#dc3545';
      case 'important': return '#ffc107';
      case 'normal': return '#28a745';
      default: return '#6c757d';
    }
  };

  const getCategoryIcon = (category) => {
    switch(category) {
      case 'general': return '📌';
      case 'noise': return '🔇';
      case 'parking': return '🚗';
      case 'pets': return '🐕';
      case 'safety': return '🔒';
      case 'common_areas': return '🏢';
      default: return '📋';
    }
  };

  return (
    <div style={{
      background: 'white',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      borderLeft: `5px solid ${getSeverityColor(rule.severity)}`
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <span style={{ fontSize: '20px' }}>{getCategoryIcon(rule.category)}</span>
            {rule.rule_number && (
              <span style={{
                padding: '2px 8px',
                background: '#e7f3ff',
                color: '#0066cc',
                borderRadius: '5px',
                fontSize: '12px',
                fontWeight: '600'
              }}>
                {rule.rule_number}
              </span>
            )}
            <h3 style={{ margin: 0, flex: 1 }}>{rule.title}</h3>
          </div>
          
          <p style={{ color: '#666', marginBottom: '10px', lineHeight: '1.6' }}>
            {rule.description}
          </p>
          
          <div style={{ display: 'flex', gap: '15px', fontSize: '14px' }}>
            <span style={{
              padding: '4px 10px',
              background: getSeverityColor(rule.severity) + '20',
              color: getSeverityColor(rule.severity),
              borderRadius: '5px',
              fontWeight: '600'
            }}>
              {rule.severity?.toUpperCase()}
            </span>
            
            {rule.fine_amount && (
              <span style={{
                padding: '4px 10px',
                background: '#fff3cd',
                color: '#856404',
                borderRadius: '5px'
              }}>
                Fine: ₹{rule.fine_amount}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RuleCard;